export default "__VITE_ASSET__CMhSCAmM__"